import React, { useState, useEffect, useRef } from 'react';
import { init } from '../utils/telegramSdk';



export function UpgradeConfirmationSheet({
                                             isVisible,
                                             onConfirm,
                                             onCancel,
                                             upgradeDetails,
                                             keyName
                                         }) {
    const [countdown, setCountdown] = useState(3);
    const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);
    const timerRef = useRef(null);


    // В компоненте
    useEffect(() => {
        const initAndDisableSwipe = async () => {
            const webApp = window.Telegram?.WebApp;
            const supportsClosingConfirmation = Boolean(
                webApp?.initData &&
                typeof webApp.isVersionAtLeast === 'function' &&
                webApp.isVersionAtLeast('6.2')
            );
            if (!supportsClosingConfirmation) return;

            try {
                await init();

                // Метод для запрета закрытия свайпом
                webApp.enableClosingConfirmation();
            } catch (error) {
                console.error('Ошибка инициализации:', error);
            }
        };

        if (isVisible) {
            initAndDisableSwipe();
        }

        return () => {
            const webApp = window.Telegram?.WebApp;
            if (
                webApp?.initData &&
                typeof webApp.isVersionAtLeast === 'function' &&
                webApp.isVersionAtLeast('6.2')
            ) {
                webApp.disableClosingConfirmation();
            }
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible) {
            setCountdown(3);
            setIsConfirmEnabled(false);

            timerRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        setIsConfirmEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [isVisible]);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            onCancel();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = () => {
            const diff = currentY || 0;

            if (diff > 100) {
                onCancel();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleConfirm = () => {
        if (isConfirmEnabled) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        onCancel();
    };

    if (!upgradeDetails) return null;

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleCancel}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet change"
            >
                <div className="sheet-content" style={{ gap: '8px' }}>
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" style={{ width: '32px', height: '3px' }} />
                    </div>

                    <h3 className="sheet-title" style={{ fontSize: '16px', margin: '0' }}>
                        Подтверждение смены тарифа
                    </h3>

                    <div style={{ textAlign: 'center' }}>
                        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px' }}>
                            Ключ {keyName}
                        </p>
                    </div>

                    {/* Блок перерасчета времени */}
                    <div className="custom-content-box" style={{
                        background: 'linear-gradient(40deg, rgba(64, 82, 73, 0.3) 50%, #2a5a3a 100%)',
                        borderRadius: '12px',
                        padding: '10px 12px',
                        marginBottom: '0',
                        border: 'none'
                    }}>
                        <div style={{ textAlign: 'center', marginBottom: '6px' }}>
                            <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', fontWeight: '500' }}>
                                Перерасчет времени
                            </span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
                            <div style={{ flex: 1, textAlign: 'center' }}>
                                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginBottom: '2px' }}>
                                    Текущий
                                </div>
                                <div style={{ color: '#ffffff', fontSize: '12px', fontWeight: '500' }}>
                                    {upgradeDetails.currentTimeRemaining}
                                </div>
                            </div>
                            <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '16px' }}>→</div>
                            <div style={{ flex: 1, textAlign: 'center' }}>
                                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginBottom: '2px' }}>
                                    Новый
                                </div>
                                <div style={{ color: '#ff4757', fontSize: '12px', fontWeight: '500' }}>
                                    {upgradeDetails.newTimeRemaining}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Кнопки */}
                    <div className="sheet-buttons" style={{ gap: '8px', marginTop: '4px', paddingBottom: '25px' }}>
                        <button
                            className="sheet-button sheet-button-cancel"
                            onClick={handleCancel}
                            style={{ height: '55px', fontSize: '12px', borderRadius: '14px' }}
                        >
                            Отмена
                        </button>
                        <button
                            className={`sheet-button sheet-button-confirm ${!isConfirmEnabled ? 'disabled' : ''}`}
                            onClick={handleConfirm}
                            disabled={!isConfirmEnabled}
                            style={{ height: '55px', fontSize: '12px', borderRadius: '14px'}}
                        >
                            {isConfirmEnabled ? 'Пересчитать тариф' : `Подождите ${countdown}с`}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
